// extracted by mini-css-extract-plugin
export var optionGrid = "_45-7";
export var optionList = "_45-6";
export var questionsBlock = "_45-9";
export var spacer = "_45-5";
export var stepCenteredContent = "_45-3";
export var stepInner = "_45-0";
export var stepInnerFullWidth = "_45-1";
export var stepInnerLockScroll = "_45-2";
export var stepTransitionFrame = "_45-4";
export var welcomeBlock = "_45-8";